export default "__VITE_PUBLIC_ASSET__ea80a06d__"